import './Icon_Chevron_Right.css';
 
function Icon_Chevron_Right() {
  return (
    <div className='icon-container-chevron-right'>
      <svg viewBox="0 0 20 20" className="chevron-right-svg">
        <path d="m8 16 6-6-6-6"/></svg>
    </div>
  );
}
 
export default Icon_Chevron_Right;
 
//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right-icon lucide-chevron-right">
// <path d="m9 18 6-6-6-6"/></svg>